export default {
  appInfo: {
    state: {
      configuration: 'Configuration',
      downloaded: 'Downloaded',
      heading: 'Application State Information',
      lastUpdated: 'Last updated',
      noConfiguration: 'There is no configuration available',
      questionsAnswered: 'No questions answered | {n} question answered | {n} questions answered',
      storedResponses: 'Stored Survey Responses',
      surveyDetails: 'Survey Details',
      surveyInProgress: 'A survey is currently in progress',
      surveyNotInProgress: 'There are no surveys currently in progress',
      surveyProgress: 'Survey Progress',
      surveysAvailable: 'No surveys available | {n} survey available | {n} surveys available',
      surveysStored: 'No responses awaiting upload | {n} response awaiting upload | {n} responses awaiting upload',
      updateAvailable: 'Update available',
      updateDownloading: 'Update downloading'
    },
    version: 'App Version',
    appUpdated: 'App updated to latest version',
    sinceConfigUpdate: 'You last updated the app configuration yesterday | You last updated the app configuration {days} days ago',
    sinceSurveyUpload: 'Your last completed survey was uploaded {days} days ago | Your last completed surveys were uploaded {days} days ago',
    sinceSurveyUploadYesterday: 'Your last completed survey was uploaded yesterday | Your last completed surveys were uploaded yesterday',
    sinceMenuItemUpdate: 'You last updated the menu items a week ago | You last updated the menu items {days} days ago',
    // TODO: Confirm wording
    install: {
      install: 'Install',
      installTitle: 'Install 125 Data & Insights',
      installDesc: 'If this app is not already installed on your device, please install it to continue.',
      installInstructionsDesc: 'If this app is already installed on your device please open it from the homescreen or follow the below instructions on how to install.',
      installInstructionsLabel: 'Click to view instructions on how to install',
      appInstalled: 'App Installed',
      appInstalledDesc: 'Please open this from your homescreen to continue.',
      iosPressShareButton: 'Press the share button',
      iosPressAddToHomescreen: 'Press "Add to Homescreen"',
      unsupportedDeviceTitle: 'Unsupported Device',
      unsupportedDeviceDesc: 'Please use either an IOS or Android device.',
      unsupportedBrowserTitle: 'Unsupported Browser',
      unsupportedBrowserDesc: 'This app is only available for {n}.',
      pressMenuIcon: 'Press the menu icon on the browser toolbar.',
      chromePressInstallApp: 'Then press "Install App" and follow the steps to get the app installed on your device.',
      samsungPressAddPageTo: 'Press "Add page to"',
      samsungPressHomeScreen: 'Press "Home screen" and follow the steps',
      safari: 'Safari',
      samsungInternet: 'Samsung Internet',
      chrome: 'Chrome'
    }
  }
};